<!--典型业务场景-->

<template>
    <div class='all-body'>
        <div class='child-body'>
            <div class='scenarioTitle'>{{name}}</div>
            <div class='scenarioAll'>
                <ul>
                    <li  v-for="(item,index) of data"  @mouseover='TargetHover(item,index)' :class="{'tabActive':tagActive == index}">{{index}}</li>
                </ul>
                <div class='scenarioContent'>
                    <!-- 应用价值 -->
                    <div class="scenarioOne" v-for="(item,index) of data[tagActive].html">
                            <div class='scenarioCon' v-if="index !='img' && index !='方案中所继承的法律AI服务'">
                                <div class="scenarioContentTitle">
                                {{index}}
                                </div>
                                <div :class='{"scenarioOne-content":index =="应用价值","scenarioOne-content-common":true}'>
                                    {{item}}
                                </div>
                            </div>  
                            <!-- 应用价值 -->
                            <div class='scenarioOneImg' v-if="index =='应用价值'">
                                <img :src="data[tagActive].img" alt="">
                            </div>
                        <!-- 方案中所集成的法律AI服务 -->
                        <div class='scenarioConAI' v-if="index =='方案中所继承的法律AI服务'">
                            <div class="scenarioContentTitle">
                              {{index}}
                            </div>
                            <div :class='{"scenarioOne-content":index =="应用价值","scenarioOne-content-common":true,"scenarioOneAI":true}'>
                                 {{item}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import '../../assets/public.css'
export default {
    name: 'index',
    props: ['data','name'],
    data() {
        return {
            tagActive:''      // 高亮标签
        }
    },
    mounted() {
        this.tagActive=Object.keys(this.data)[0]
    },
    methods: {
        // tab 悬浮
        TargetHover(item,index){
            this.tagActive=index;// 高亮下标
        }
    }
}
</script>

<style scoped>
    .scenarioAll{
        border: 1px solid #E4E4E4;
        display: flex;
    }
    .scenarioAll ul{
        width: 183px;
        height: 468px;
        background: #F6F7FA;
    }
    .scenarioAll li{
        width: 183px;
        height: 62px;
        color: #303133;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 62px;
        text-align: center;
        cursor: pointer;
    }
    .tabActive{
        background: #1867DD;
        color: #F7F7F7 !important;
    }
    .scenarioOne{
        display: flex;

    }
    .scenarioContent{
        padding: 45px 45px 0 45px;
    }
    .scenarioConAI{
        display: flex;
    }
    .scenarioContentTitle{
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #262626;
        margin-bottom: 30px;
    }
    .scenarioOne-content{
        width: 602px;
    }
    .scenarioOne-content-common{
        margin-bottom: 60px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #606266;
        line-height: 30px;
    }
    .scenarioOneAI{
        margin-left: 45px;
        color: #1867DD;
    }
    .scenarioOne-content{
        margin-right: 45px;
    }
    .scenarioOneImg{
        width: 280px;
        height: 158px;
    }
    
    
</style>